import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useApp();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-[hsl(var(--background))]">
                <div className="text-[hsl(var(--muted-foreground))] text-sm">Cargando...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/" replace state={{ from: location }} />;
    return children;
};

export default ProtectedRoute;
